import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';

export type BankCode = {
  code: string;
  name: string;
};

export type BankCodesResponse = {
  list: BankCode[];
};

/**
 * 은행 코드 목록 조회
 *
 * Origin: pageBillingApi.getBankCodes
 * API: GET /v1/dkpg/bank-codes
 */
export async function getBillingDkpgBankCodes(
  options?: FetcherOptions
): Promise<BankCodesResponse> {
  const response = await axiosBffFetch(
    '/api/billing/v1/dkpg/bank-codes',
    {
      method: 'GET',
    },
    options
  );
  return response.data;
}
